/**
 * Utilities for analyzing parsed poker hand ranges
 */

import { HAND_METADATA } from '@/data/handMetadata';

export interface RangeAnalysis {
  total: number;
  pairs: number;
  suited: number;
  offsuit: number;
  hands: string[];
}

/**
 * Analyze a list of hand names and return counts by type
 */
export function analyzeRange(hands: string[]): RangeAnalysis {
  let pairs = 0;
  let suited = 0;
  let offsuit = 0;

  for (const hand of hands) {
    const metadata = HAND_METADATA[hand];
    if (!metadata) continue;

    switch (metadata.type) {
      case 'pair':
        pairs++;
        break;
      case 'suited':
        suited++;
        break;
      case 'offsuit':
        offsuit++;
        break;
    }
  }

  return {
    total: hands.length,
    pairs,
    suited,
    offsuit,
    hands,
  };
}
